"use strict";

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var _require = require("./header-types"),
    isForbidden = _require.isForbidden,
    isForbiddenResponse = _require.isForbiddenResponse,
    isPrivilegedNoCORSRequest = _require.isPrivilegedNoCORSRequest,
    isNoCORSSafelistedRequest = _require.isNoCORSSafelistedRequest,
    isCORSWhitelisted = _require.isCORSWhitelisted;

var HeaderList = require("./header-list");

function assertName(name) {
  if (!name.match(/^[!#$%&'*+\-.^`|~\w]+$/)) {
    throw new TypeError("name is invalid");
  }
}

function assertValue(value) {
  if (value.match(/[\0\r\n]/)) {
    throw new TypeError("value is invalid");
  }
}

var HeadersImpl = /*#__PURE__*/function (_Symbol$iterator) {
  function HeadersImpl(globalObject, args) {
    _classCallCheck(this, HeadersImpl);

    this.guard = "none";
    this.headersList = new HeaderList();

    if (args[0]) {
      this._fill(args[0]);
    }
  }

  _createClass(HeadersImpl, [{
    key: "_fill",
    value: function _fill(init) {
      if (Array.isArray(init)) {
        var _iterator = _createForOfIteratorHelper(init),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var header = _step.value;

            if (header.length !== 2) {
              throw new TypeError("init is invalid");
            }

            this.append(header[0], header[1]);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } else {
        for (var _i = 0, _Object$keys = Object.keys(init); _i < _Object$keys.length; _i++) {
          var key = _Object$keys[_i];
          this.append(key, init[key]);
        }
      }
    }
  }, {
    key: "has",
    value: function has(name) {
      assertName(name);
      return this.headersList.contains(name);
    }
  }, {
    key: "get",
    value: function get(name) {
      assertName(name);
      return this.headersList.get(name);
    }
  }, {
    key: "_removePrivilegedNoCORSHeaders",
    value: function _removePrivilegedNoCORSHeaders() {
      this.headersList.delete("range");
    }
  }, {
    key: "append",
    value: function append(name, value) {
      value = value.trim();
      assertName(name);
      assertValue(value);

      switch (this.guard) {
        case "immutable":
          throw new TypeError("Headers is immutable");

        case "request":
          if (isForbidden(name)) {
            return;
          }

          break;

        case "request-no-cors":
          {
            var temporaryValue = this.get(name);

            if (temporaryValue === null) {
              temporaryValue = value;
            } else {
              temporaryValue += ", ".concat(value);
            }

            if (!isCORSWhitelisted(name, value)) {
              return;
            }

            break;
          }

        case "response":
          if (isForbiddenResponse(name)) {
            return;
          }

          break;
      }

      this.headersList.append(name, value);

      this._removePrivilegedNoCORSHeaders();
    }
  }, {
    key: "set",
    value: function set(name, value) {
      value = value.trim();
      assertName(name);
      assertValue(value);

      switch (this.guard) {
        case "immutable":
          throw new TypeError("Headers is immutable");

        case "request":
          if (isForbidden(name)) {
            return;
          }

          break;

        case "request-no-cors":
          {
            if (!isCORSWhitelisted(name, value)) {
              return;
            }

            break;
          }

        case "response":
          if (isForbiddenResponse(name)) {
            return;
          }

          break;
      }

      this.headersList.set(name, value);

      this._removePrivilegedNoCORSHeaders();
    }
  }, {
    key: "delete",
    value: function _delete(name) {
      assertName(name);

      switch (this.guard) {
        case "immutable":
          throw new TypeError("Headers is immutable");

        case "request":
          if (isForbidden(name)) {
            return;
          }

          break;

        case "request-no-cors":
          {
            if (!isNoCORSSafelistedRequest(name) && !isPrivilegedNoCORSRequest(name)) {
              return;
            }

            break;
          }

        case "response":
          if (isForbiddenResponse(name)) {
            return;
          }

          break;
      }

      this.headersList.delete(name);

      this._removePrivilegedNoCORSHeaders();
    }
  }, {
    key: _Symbol$iterator,
    value: /*#__PURE__*/_regeneratorRuntime.mark(function value() {
      var _iterator2, _step2, header;

      return _regeneratorRuntime.wrap(function value$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _iterator2 = _createForOfIteratorHelper(this.headersList.sortAndCombine());
              _context.prev = 1;

              _iterator2.s();

            case 3:
              if ((_step2 = _iterator2.n()).done) {
                _context.next = 9;
                break;
              }

              header = _step2.value;
              _context.next = 7;
              return header;

            case 7:
              _context.next = 3;
              break;

            case 9:
              _context.next = 14;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](1);

              _iterator2.e(_context.t0);

            case 14:
              _context.prev = 14;

              _iterator2.f();

              return _context.finish(14);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, value, this, [[1, 11, 14, 17]]);
    })
  }]);

  return HeadersImpl;
}(Symbol.iterator);

exports.implementation = HeadersImpl;